<template>
  <div class="flex min-h-screen flex-col">
    <TemplateHeader />
    <main class="public-page mt-40 flex-1">
      <slot />
    </main>
    <TemplateFooter />
    <ClientOnly>
      <ChatBaseWidget />
      <template #fallback />
    </ClientOnly>
    <LanguageModal />
  </div>
</template>
<script setup lang="ts">
import LanguageModal from "~/features/translation/components/LanguageModal.vue";
import TemplateFooter from "~/shared/components/layout/TemplateFooter.vue";
import TemplateHeader from "~/shared/components/layout/TemplateHeader.vue";
const ChatBaseWidget = defineAsyncComponent(
  () => import("~/features/chatbase/ChatBaseWidget.vue"),
);
import { useSiteSettings } from "~/slices/settings/composables/settings";
import { useUnread } from "~/slices/users/composables/api";

const queryAfterPaint = ref(false);
provide("queryAfterPaint", queryAfterPaint);
useSiteSettings();
const { runAfterPaint: runUnreadAfterPaint } = useUnread();

onMounted(() => {
  const runAfterPaint = () => {
    queryAfterPaint.value = true;
    runUnreadAfterPaint?.();
  };
  if (typeof requestIdleCallback !== "undefined") {
    requestIdleCallback(runAfterPaint, { timeout: 500 });
  } else {
    setTimeout(runAfterPaint, 0);
  }
});
</script>
<style scoped>
.public-page :deep(h1) {
  color: #000;
}
</style>
